import * as React from "react";
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 7, viewBox: "0 0 12 7", width: 12, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m.97168 1 5.23364 5 5.23368-5", stroke: "#aeaeae" }));
export default SvgDropdown;
